<template>
<div class="homeSite">

    <div class="section">
        <div class="text-center">

            <v-btn elevation="0" dark class="ma-1" color="red darken-4" :to="{name :'Category',params:{category_slug:'product-knowledge'}}">PRODUCT KNOWLEDGE</router-link></v-btn>

            <v-btn :small="($vuetify.breakpoint.xs) ? true:false" outlined class="ma-1" color="grey darken-1" :to="{name:'CategorySub',params:{category_slug:'product-knowledge',sub_slug:'automatic' }}">
                Automatic
            </v-btn>
            <v-btn :small="($vuetify.breakpoint.xs) ? true:false"outlined class="ma-1"  color="grey darken-1" :to="{name:'CategorySub',params:{category_slug:'product-knowledge',sub_slug:'sport'}}">
                Sport
            </v-btn>
            <v-btn :small="($vuetify.breakpoint.xs) ? true:false" outlined class="ma-1" color="grey darken-1"  :to="{name:'CategorySub',params:{category_slug:'product-knowledge',sub_slug:'moped'}}">
                Moped
            </v-btn>

        </div>
        <div class="contentItems mt-3 hover01 product-knowledgeList" v-if="products">
            <div class="row">

                <div class="col-sm-3" v-for="(item,i) in products" :key="i">
                    <ContentListBox :item="item" />
                </div>
            </div>

        </div>
    </div>

    <div class="section">
        <div class="row start">
            <div class="col-sm-6 contentItems mt-3 hover01 defaultList2" v-if="tech">

                <div  class="homeIcon mb-3"><router-link :to="{name :'Category',params:{category_slug:'technician-in-sales'}}"><img :src="icon+'technician-in-sales.svg'" /></router-link></div>
                <div class="row">
                    <div class="col-sm-6" v-for="(item,i) in tech" :key="i">
                        <ContentListBox :item="item" elevation="0" />
                    </div>
                </div>

            </div>
            <div class="col-sm-6 contentItems mt-3 hover01 defaultList" v-if="digital">

                <div    class="homeIcon mb-3"><router-link :to="{name :'Category',params:{category_slug:'digital-marketing'}}"><img :src="icon+'digital-marketing.svg'" /></router-link></div>
                <div class="row">
                    <div class="col-sm-6" v-for="(item,i) in digital" :key="i">
                        <ContentListBox :item="item" elevation="0" />
                    </div>
                </div>

            </div>
        </div>

    </div>

    <div class="section" v-if="test">

        <v-card elevation="0">
           

     <div    class="homeIcon pt-2 pl-2 contest"><router-link  :to="{name :'Category',params:{category_slug:'TestContest'}}"><img :src="icon+'TestContest.svg'"  /></router-link></div> 
 
      
           
            <v-card-text >
                
                <div class="row contestItems   test-contestList">
                    <div class="col-sm-3" v-for="(item,i) in test" :key="i">
                        <ContentListBox :item="item" />
                    </div>
                </div>
                 
            </v-card-text>
        </v-card>

    </div>

    <div class="section" v-if="news">
        <div class="homeIcon"><router-link :to="{name :'Category',params:{category_slug:'news-announce'}}"><img :src="icon+'news-announce.svg'" /></router-link></div>
        <div class="contentItems mt-3 hover01 news-announceList">
            <div class="row">
                <div class="col-sm-6" v-if="news[1]">
                    <ContentListBox :item="news[1]" />
                </div>
                <div class="col-sm-6">
                    <div class="row" v-if="newsOther">
                        <div class="col-sm-6" v-for="(item,i) in newsOther" :key="i">
                           
                            <ContentListBox :item="item" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
export default {

    components: {

    },

    data: () => ({
        icon:null,
        news: null,
        newsOther:null,
        tech: null,
        test: null,
        digital: null,
        home: null,
        products: null
    }),

    computed: {

    },

    watch: {

    },
    methods: {
        getItem() {

            let url = "home/get";

            this.$FULL_LOADING = true
            let $vm = this;
            this.$API
                .post(url, this.formData())
                .then(function (res) {

                    $vm.checkApi(res);
                    $vm.news = res.data.news
                    $vm.products = res.data.products
                    $vm.digital = res.data.digital
                    $vm.tech = res.data.tech
                    $vm.home = res.data.home
                    $vm.test = res.data.test
                    $vm.newsOther = res.data.newsOther
                    $vm.icon = res.data.icon
                    

                })
                .catch(function (error) {
                    console.log(error);
                });

        }

    },
    created() {

        this.$MEMBER_ONLY_TEXT = null
        this.$CURRENT_CONTENT_ID = null

        this.getItem()

    },
};
</script>
